import React from 'react'
import pizzaLeft from '../assets/pizzaLeft.jpg'
import '../styles/Contact.css'
const Contact = () => {
  return (
    <div className='contact'>
      <div className='leftSide' style={{backgroundImage:`url(${pizzaLeft})`}}></div>
      <div className='rightSide'>
      <h1>Conatct Us</h1>
        <form id='contact-form'>
          <label htmlFor='name'>Full Name</label>
          <input name='name' placeholder='Enter Your Name' type='text'/>
          <label htmlFor='email'>Email</label>
          <input name='email' placeholder='Enter Your Mail' type='text'/>
          <label htmlFor='message'>Message</label>
          <textarea rows='6' placeholder='Enter Your Message' name='message'/>
          <button type='submit'>Send Message</button>
        </form>
      </div>
    </div>
  )
}

export default Contact
